import { createAction, createReducer } from "@reduxjs/toolkit";
import { RootState } from "store/types";
import { createDeepEqualSelector } from "store/utils";

// Types

export type UIState = {
  isSideNavigationCollapsed: boolean;
  isIntelligenceGradientVisible: boolean;
};

// Actions & Thunks

export const setIsSideNavigationCollapsed = createAction<boolean>("appState/ui/setIsSideNavigationCollapsed");

export const toggleIsSideNavigationCollapsed = createAction<void>("appState/ui/toggleIsSideNavigationCollapsed");

export const setIsIntelligenceGradientVisible = createAction<boolean>("appState/ui/setIsIntelligenceGradientVisible");

// Reducer

export const initialState: UIState = {
  isSideNavigationCollapsed: false,
  isIntelligenceGradientVisible: false,
};

export const uiReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setIsSideNavigationCollapsed, (draft, action) => {
      draft.isSideNavigationCollapsed = action.payload;
    })
    .addCase(toggleIsSideNavigationCollapsed, (draft, action) => {
      draft.isSideNavigationCollapsed = !draft.isSideNavigationCollapsed;
    })
    .addCase(setIsIntelligenceGradientVisible, (draft, action) => {
      draft.isIntelligenceGradientVisible = action.payload;
    });
});

// Selectors

const selectUIState = (state: RootState) => state.appState.ui;

export const selectIsSideNavigationCollapsed = createDeepEqualSelector([selectUIState], (state: UIState) => {
  return state.isSideNavigationCollapsed;
});

export const selectIsIntelligenceGradientVisible = createDeepEqualSelector([selectUIState], (state: UIState) => {
  return state.isIntelligenceGradientVisible;
});
